import { Component, EventEmitter, Inject, OnInit, Output } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { BehaviorSubject, Subject } from 'rxjs';
import { NonSalesService } from './non-sales.service';

@Component({
  selector: 'app-non-sales',
  templateUrl: './non-sales.component.html',
  styleUrls: ['./non-sales.component.css']
})
export class NonSalesComponent implements OnInit {
  @Output() successfulSubmission: EventEmitter<any> = new EventEmitter<any>();
  nonsalesForm!: FormGroup;
  submitted = false;
  formData: any;
  masters: any = [];
  nonSalesCategories: any = [];
  isLoading: Subject<boolean> = new Subject<boolean>();
  isServiceSelected: boolean = false;
  leadId: string | undefined;

  constructor(public dialogRef: MatDialogRef<NonSalesComponent>, private formBuilder: FormBuilder, private nonSalesService: NonSalesService,
    private toastr: ToastrService, @Inject(MAT_DIALOG_DATA) public data: any,
  ) { }

  isUpdate: boolean = false;
  category: any = '';
  ngOnInit() {
    this.leadId = this.data.leadId;
    this.isUpdate = this.data.isUpdate;
    console.log(this.data, 'data in non sales');
    if(this.data.category_id && this.data.category){
        this.category = this.data.category_id + ':' + this.data.category;
    }
    const masters = JSON.parse(sessionStorage.getItem('masters') || '{}');

    if (masters) {
      this.masters = masters;
      this.nonSalesCategories = this.masters.nonSalesCategories || [];
      console.log(this.nonSalesCategories, 'this.nonSalesCategories');
      

    }

    this.nonsalesForm = this.formBuilder.group({
      category: [this.category, Validators.required],
      registration_number: [this.data.registration_number || ''],
      remarks: [''],
      lead_id: [this.leadId],
      stage_id: 6,
    });
  }

  get f() {
    return this.nonsalesForm.controls
  }

  onRegistrationNumberInput(event: any): void {
    const input = event.target;
    input.value = input.value.replace(/[^0-9]/g, '');
  }
  
  onCategoryChange(event: any) {
    const selectedCategory = event.target.value.split(':')[0];

    if (selectedCategory == 1) {
      this.isServiceSelected = true;
      console.log(true);
      
      this.nonsalesForm.addControl('registration_number', this.formBuilder.control('', Validators.required));
    } else {
      this.isServiceSelected = false;
      console.log(false);
      
      this.nonsalesForm.removeControl('registration_number');
    }
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  onSubmit(): void {
    this.submitted = true;
    if (!this.nonsalesForm.valid) {
      return;
    } else {
      const formData: any = this.nonsalesForm.value;

      this.isLoading = new BehaviorSubject<boolean>(true);
      this.nonSalesService.nonsales(formData).subscribe((response: any) => {
        let responseData = response.body;
        if (responseData.responseCode == 200) {
          this.successfulSubmission.emit();
          this.dialogRef.close(this.formData);
          this.isLoading = new BehaviorSubject<boolean>(false);
          this.toastr.success("Lead Moved to Non Sales successfully!");
        } else {
          this.isLoading = new BehaviorSubject<boolean>(false);
          this.toastr.error("Please try again later!");
        }
      }, (err: any) => {
        this.isLoading = new BehaviorSubject<boolean>(false);
      });
    }
  }

  onUpdate(){
  this.submitted = true;
    if (!this.nonsalesForm.valid) {
      return;
    } else {
      const formData: any = this.nonsalesForm.value;
      let req = {
        non_sales_category: formData.category.split(':')[0],
        remarks: formData.remarks,
        registration_number: formData?.registration_number ? formData.registration_number : undefined,
      }
      this.isLoading = new BehaviorSubject<boolean>(true);
      this.nonSalesService.updateNonsales(req, this.leadId).subscribe((response: any) => {
        let responseData = response.body;
        if (responseData.responseCode == 200) {
          this.successfulSubmission.emit();
          this.dialogRef.close(this.formData);
          this.isLoading = new BehaviorSubject<boolean>(false);
          this.toastr.success("Updated successfully!");
        } else {
          this.isLoading = new BehaviorSubject<boolean>(false);
          this.toastr.error("Please try again later!");
        }
      }, (err: any) => {
        this.isLoading = new BehaviorSubject<boolean>(false);
      });
    }
  }
}